<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<div><a id="listoffigures"></a></div><a id="listoffigures">
<h1>LIST OF FIGURES</h1>
<p class="bigspace"> </p>
</a><p class="figure"><a id="listoffigures"></a><span href="#/html/10_chap4#fig1" title="Link target outside of Sample">Figure 1 Three-Fingered Front, Top View</span></p>
<p class="figure"><span href="#/html/10_chap4#fig2" title="Link target outside of Sample">Figure 2 Three-Fingered Front, Near-Face View</span></p>
<p class="figure"><span href="#/html/10_chap4#fig3" title="Link target outside of Sample">Figure 3 Three-Fingered Front, Side View</span></p>
<p class="figure"><span href="#/html/10_chap4#fig4" title="Link target outside of Sample">Figure 4 Three-Fingered Front, Far-Face View</span></p>
<p class="figure"><span href="#/html/10_chap4#fig5" title="Link target outside of Sample">Figure 5 More Contact With Ring Finger Than Index Finger</span></p>
<p class="figure"><span href="#/html/12_chap6#fig6" title="Link target outside of Sample">Figure 6 Example of Hardways Set</span></p>
<p class="figure"><span href="#/html/12_chap6#fig7" title="Link target outside of Sample">Figure 7 Example of Sevens Set</span></p>
<p class="figure"><span href="#/html/12_chap6#fig8" title="Link target outside of Sample">Figure 8 Example of 3-V Set</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_figures.vue?161b4a20